import Swiper from "swiper/swiper-bundle";

export const priceSlider = () => {
  const slider = new Swiper(".price-slider", {
    loop: true,
    spaceBetween: 120,
    pagination: {
      el: ".price-slider__pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".price-slider__next",
      prevEl: ".price-slider__prev",
    },
  });
};
